/**
 * PHP legacy datetimes are China wall-clock strings; the API often serializes them
 * with a trailing Z (treated as UTC). Use UTC date parts — not local — for display parity.
 */

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/** YYYY-MM-DD for hall cards and list rows. */
export function formatLegacyPhpDate(value: string): string {
  const s = value.trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const date = new Date(s);
  if (Number.isNaN(date.getTime())) return s.slice(0, 10);
  return `${date.getUTCFullYear()}-${pad2(date.getUTCMonth() + 1)}-${pad2(date.getUTCDate())}`;
}

/** YYYY-MM-DD HH:mm:ss for detail views. */
export function formatLegacyPhpDateTime(value: string): string {
  const s = value.trim();
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) return s;
  const date = new Date(s);
  if (Number.isNaN(date.getTime())) return s.replace('T', ' ').slice(0, 19);
  return `${date.getUTCFullYear()}-${pad2(date.getUTCMonth() + 1)}-${pad2(date.getUTCDate())} ${pad2(date.getUTCHours())}:${pad2(date.getUTCMinutes())}:${pad2(date.getUTCSeconds())}`;
}
